import TemplateForm from "./TemplateForm";

const CreateTemplate = ({ closeModal, refetch, setPage }) => {
  return <TemplateForm closeModal={closeModal} refetch={refetch} setPage={setPage} />;
};

export default CreateTemplate;
